import { render, staticRenderFns } from "./VTSection.vue?vue&type=template&id=1050c39b&scoped=true&"
import script from "./VTSection.vue?vue&type=script&lang=js&"
export * from "./VTSection.vue?vue&type=script&lang=js&"
import style0 from "./VTSection.vue?vue&type=style&index=0&id=1050c39b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050c39b",
  null
  
)

export default component.exports